class ProductCard extends HTMLElement {

    constructor() {
        super()
        this.init()
    }

    /**
     * The `init` function initializes the component by setting up event listeners.
     */
    private init(): void {
        this.setupEventListeners()
    }

    /**
     * The function sets up event listeners for changing color, opening quick add, and closing quick
     * add.
     */
    private setupEventListeners(): void {
        this.initChangeFlavorEvent()
    }

    /**
     * The function removes the 'selected' class from all color variants
     * except for the specified `colorVariant`.
     * @param {any} colorVariant
     */
    private deselectedFlavorVariants(flavorVariant: any): void {
        const flavorVariants = this.querySelectorAll('.product-card__flavor-variant')

        flavorVariants.forEach((item) => {
            if (item !== flavorVariant) {
                item.classList.remove('selected')
            } else {
                item.classList.add('selected')
            }
        })
    }

    /**
     * The function updates product thumbnails based on the selected color.
     * @param {string | null} color
     */
    private changeProductThumbnails(flavor: string | null): void {
        const imagesContainer = this.querySelector('.product-card__thumbs')
        let images = imagesContainer?.querySelectorAll('img')
        const productMedia = this.querySelector('[data-product-media]')?.textContent
        const productMediaJSON = productMedia ? JSON.parse(productMedia) : ''
        const productMediaSelect = productMediaJSON.filter((media: { alt: string | null }) => media.alt === flavor)

        images?.forEach((image, index) => {
            image.src = productMediaSelect[index].src + '&width=450&height=450&crop=center'
        })
    }

    /**
     * The function initializes a click event listener on color variants in a
     * product card, updating the product details and thumbnails based on the selected color.
     */
    private initChangeFlavorEvent(): void {
        const flavorVariants = this.querySelectorAll('.product-card__flavor-variant')
        
        flavorVariants.forEach((flavorVariant) => {
            flavorVariant.addEventListener('click', () => {
                const flavor = flavorVariant.getAttribute('data-flavor')
                const variantUrl = flavorVariant.getAttribute('data-url') || ''
                const isAvailable = flavorVariant.getAttribute('data-available')
                const variantId = flavorVariant.getAttribute('data-variant-id')

                this.querySelector('.product-card__thumbs')?.setAttribute('href', variantUrl)
                this.querySelector('.product-card__name-pricing')?.setAttribute('href', variantUrl)
                this.querySelector('#variant-id')?.setAttribute('value', variantId || '')

                const btn = this.querySelector('.btn') || document.createElement('button')

                if( isAvailable == 'false' ) { 
                    btn?.classList.add('btn-bone')
                    btn?.classList.remove('btn-night')
                    btn?.classList.remove('add-to-cart')
                    btn.textContent = 'Sold Out'
                } else {
                    btn?.classList.remove('btn-bone')
                    btn?.classList.add('btn-night')
                    btn?.classList.add('add-to-cart')
                    btn.textContent = 'Add to Cart'
                }

                this.deselectedFlavorVariants(flavorVariant)
                this.changeProductThumbnails(flavor)
            })
        })
    }
}

export default ProductCard